import React, { useEffect, useRef, useState } from 'react'
import { fetchLeadByQuotationNumber } from '../../../store/slices/fetchLeadByQuotationNumberSlice';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useCurrencySymbol } from '../../../utils/currencyUtils';
import DateConversion from '../../../utils/DateConversion';
import { SquarePen, Trash2 } from "lucide-react";
import { goNext, goToStep, resetStep, setCreatedProject, setEditProjectID, setExistingEditAdvancedProject, setExistingProjectLeadId, setExistingSearchClientName, setExistingSearchGroupName, setExistingSearchProjectName, setOperationProjectStatus } from '../../../store/slices/WizardSlice/wizardStepSlice';
import CommaConvert from '../../../utils/CommaConvert';
import useMatchedProject from '../OperationWizard/useMatchedProject';
import { setcurrentLeadID, setCurrentPageTitle } from '../../../store/slices/pageSlice';
import { fetchAllProjects } from '../../../store/slices/projectsSlice';
import { setShowWizard } from '../../../store/slices/WizardSlice/WizardSlice';
import { useNavigate } from 'react-router-dom';
import { deleteLead } from '../../../store/slices/leadsSlice';
import ConfirmationModal from '../../../components/common/confirm/ConfirmationModal';
import { EllipsisVertical } from "lucide-react";
import { fetchGroups } from '../../../store/slices/groupSlice';
import { useLoggedUser } from '../../../utils/useLoggedUser';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const ExistingProjectSearch = () => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar();
  const { formatDateByCountry } = DateConversion();
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();
  const navigate = useNavigate();
  const step = useSelector((state) => state.wizardstep.step);
  const { leads } = useSelector((state) => state.leads);
  const { group } = useSelector((state) => state.group);
  const wizardPlanState = useSelector((state) => state.wizardstep.wizardPlanState);
  const wizardProjectState = useSelector((state) => state.wizardstep.wizardProjectState);
  const createdProject = useSelector((state) => state.wizardstep.createdProject);
  const { leadid } = useSelector(
    (state) => state.getLeadByQuotation
  );
  const existingSearchGroupName = useSelector((state) => state.wizardstep.existingSearchGroupName);
  const existingSearchProjectName = useSelector((state) => state.wizardstep.existingSearchProjectName);
  const existingSearchClientName = useSelector((state) => state.wizardstep.existingSearchClientName);
  const existingProjectLeadId = useSelector((state) => state.wizardstep.existingProjectLeadId);
  const currentLeadID = useSelector((state) => state.page.currentLeadID);
  const operationProjectStatus = useSelector((state) => state.wizardstep.operationProjectStatus);
  const loggedUser = useLoggedUser();

  const [, SetisLoading] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedProjectName, setSelectedProjectName] = useState("");

  const [uniqueClientLeads, setUniqueClientLeads] = useState([]);
  const [QuotationNumber, setQuotationNumber] = useState("");
  const [existingClientLeads, setExistingClientLeads] = useState([]);
  const [Projects, setProjects] = useState([]);
  const [Groups, setGroups] = useState([]);
  const [isRowSelected, setIsRowSelected] = useState(false);

  console.log("createdProject currentLeadID", currentLeadID)
  console.log("createdProject", createdProject)
  console.log("createdProject existingClientLeads", existingClientLeads)
  console.log("createdProject operationProjectStatus", operationProjectStatus)
  console.log("selectedProjectName existingClientLeads", existingClientLeads)

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;

  const currentItems = existingClientLeads.slice(startIdx, endIdx);

  const totalItems = existingClientLeads.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Reset all search inputs and results to fresh state whenever the Existing Project module is accessed
  useEffect(() => {
    dispatch(setExistingSearchGroupName(""));
    dispatch(setExistingSearchClientName(""));
    dispatch(setExistingSearchProjectName(""));
    dispatch(setExistingProjectLeadId(""));
    setSelectedGroup("");
    setSelectedClient("");
    setSelectedProjectName("");
    setQuotationNumber("");
    setExistingClientLeads([]);
    setCurrentPage(1);
    setIsRowSelected(false);
  }, [dispatch]);

  useEffect(() => {
    if (selectedGroup) {
      dispatch(setExistingSearchGroupName(selectedGroup))
    }
    if (selectedClient) {
      dispatch(setExistingSearchClientName(selectedClient))
    } else {
      dispatch(setExistingSearchClientName(""))
    }
    if (selectedProjectName) {
      dispatch(setExistingSearchProjectName(selectedProjectName))
    }
  }, [selectedGroup, selectedClient, selectedProjectName,
    dispatch
  ])

  useEffect(() => {
    if (existingSearchGroupName) {
      setSelectedGroup(existingSearchGroupName)
    }
    if (existingSearchClientName) {
      setSelectedClient(existingSearchClientName)
    }
    if (existingSearchProjectName) {
      setSelectedProjectName(existingSearchProjectName)
    }
  }, [existingSearchGroupName, existingSearchProjectName, existingSearchClientName])

  useEffect(() => {
    if (existingProjectLeadId?.length > 9) {
      setQuotationNumber(existingProjectLeadId);
    }
    if (currentLeadID?.length > 9) {
      setQuotationNumber(currentLeadID);
    }
  }, [existingProjectLeadId, currentLeadID]);

  // QuotationNumber filtering is now handled in the unified filtering useEffect below

  const [searchedQuationNumber, setSearchedQuotationNumber] = useState([]);

  useEffect(() => {
    const quotationOptions = [
      ...new Set(
        existingClientLeads.map((proj) => proj?.quotationId).filter(Boolean)
      ),
    ];
    setSearchedQuotationNumber(quotationOptions);
  }, [existingClientLeads])

  useEffect(() => {
    dispatch(setCurrentPageTitle("Search Existing Project"));
    dispatch(fetchGroups());

    if (leadid) {
      const selectedLead = leads.filter(lead => lead?.id === leadid);
      if (selectedLead[0]?.SalesPersonStatus === "project requested") {
        dispatch(setOperationProjectStatus("project requested"));
      }
      setExistingClientLeads(selectedLead);
    }
  }, [leads, leadid, dispatch]);

  const groupNameById = React.useMemo(() => {
    const map = new Map();
    (group || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [group]);

  const resolveLeadGroupName = React.useCallback((lead) => {
    const gid = lead?.groupid?._id || lead?.groupid;
    if (gid && groupNameById.has(String(gid))) {
      return groupNameById.get(String(gid));
    }
    return lead?.AssignedGroup || "";
  }, [groupNameById]);

  useEffect(() => {
    const empGroupIds = Array.isArray(loggedUser?.EmpGroups)
      ? loggedUser.EmpGroups.map((id) => String(id))
      : [];

    const groupOptions = empGroupIds.length > 0
      ? [...new Set(empGroupIds.map((id) => groupNameById.get(id)).filter(Boolean))]
      : [...new Set(leads.map((lead) => resolveLeadGroupName(lead)?.trim()).filter(Boolean))];

    setGroups(groupOptions.sort((a, b) => a.localeCompare(b)));
  }, [leads, loggedUser, groupNameById, resolveLeadGroupName]);

  console.log("existingClientLeads1 selectedGroup", selectedGroup)
  console.log("existingClientLeads1 selectedClient", selectedClient)

  // Unified filtering function that combines all active filters
  useEffect(() => {
    // Don't override if a row was explicitly selected
    if (isRowSelected) {
      return;
    }
    
    if (currentLeadID) {
      const selectedLead = leads.filter(lead => lead?.quotationId?.toLowerCase() === currentLeadID?.toLowerCase());
      setExistingClientLeads(selectedLead)
      return;
    }

    // Check if any search criteria is provided
    const hasSearchCriteria = QuotationNumber || selectedGroup || selectedClient || selectedProjectName;

    // If no search criteria, don't show any results
    if (!hasSearchCriteria) {
      setExistingClientLeads([]);
      // Still update dropdown options for autocomplete
      const uniqueClientNames = [...new Set(leads.map(lead => lead.ClientName).filter(Boolean))];
      setUniqueClientLeads(uniqueClientNames.sort((a, b) => a.localeCompare(b)));
      const uniqueProjectNames = [...new Set(leads.map(lead => lead?.ProjectName).filter(Boolean))];
      setProjects(uniqueProjectNames.sort((a, b) => a.localeCompare(b)));
      return;
    }

    // Prioritize QuotationNumber search - if exact match found, show only that
    if (QuotationNumber && leads?.length > 0) {
      const exactMatch = leads.filter(lead => 
        lead?.quotationId?.toLowerCase() === QuotationNumber.toLowerCase()
      );
      if (exactMatch.length > 0) {
        setExistingClientLeads(exactMatch);
        return;
      }
      // If no exact match, continue with partial matching below
    }

    if (leads?.length > 0) {
      let filteredLeads = [...leads];

      // Apply filters in any combination - all filters are AND conditions
      if (QuotationNumber) {
        filteredLeads = filteredLeads.filter(lead => 
          lead?.quotationId?.toLowerCase().includes(QuotationNumber.toLowerCase())
        );
      }

      if (selectedGroup) {
        filteredLeads = filteredLeads.filter(lead => 
          resolveLeadGroupName(lead)?.toLowerCase().includes(selectedGroup.toLowerCase())
        );
      }

      if (selectedClient) {
        filteredLeads = filteredLeads.filter(lead => 
          lead.ClientName?.toLowerCase().includes(selectedClient.toLowerCase())
        );
      }

      if (selectedProjectName) {
        filteredLeads = filteredLeads.filter(lead => 
          normalize(lead?.ProjectName)?.includes(normalize(selectedProjectName))
        );
      }

      // Update dropdown options dynamically based on current filters
      // Always update client names if group is selected
      if (selectedGroup) {
        const groupFiltered = leads.filter(lead => 
          resolveLeadGroupName(lead)?.toLowerCase().includes(selectedGroup.toLowerCase())
        );
        const uniqueClientNames = [...new Set(groupFiltered.map(lead => lead.ClientName).filter(Boolean))];
        setUniqueClientLeads(uniqueClientNames.sort((a, b) => a.localeCompare(b)));
      } else {
        // If no group selected, show all client names
        const uniqueClientNames = [...new Set(leads.map(lead => lead.ClientName).filter(Boolean))];
        setUniqueClientLeads(uniqueClientNames.sort((a, b) => a.localeCompare(b)));
      }

      // Update project names based on group and/or client filters
      if (selectedGroup || selectedClient) {
        let projectFiltered = [...leads];
        if (selectedGroup) {
          projectFiltered = projectFiltered.filter(lead => 
            resolveLeadGroupName(lead)?.toLowerCase().includes(selectedGroup.toLowerCase())
          );
        }
        if (selectedClient) {
          projectFiltered = projectFiltered.filter(lead => 
            lead.ClientName?.toLowerCase().includes(selectedClient.toLowerCase())
          );
        }
        const uniqueProjectNames = [...new Set(projectFiltered.map(lead => lead?.ProjectName).filter(Boolean))];
        setProjects(uniqueProjectNames.sort((a, b) => a.localeCompare(b)));
      } else {
        // If no filters, show all project names
        const uniqueProjectNames = [...new Set(leads.map(lead => lead?.ProjectName).filter(Boolean))];
        setProjects(uniqueProjectNames.sort((a, b) => a.localeCompare(b)));
      }

      // Set the filtered results
      setExistingClientLeads(filteredLeads);
      setCurrentPage(1);
    }
  }, [leads, selectedGroup, selectedClient, selectedProjectName, currentLeadID, isRowSelected, QuotationNumber, resolveLeadGroupName]);

  const normalize = (str) =>
    str
      ?.toLowerCase()
      .trim()
      .replace(/\s+/g, " "); // collapse multiple spaces

  const handleProjectNameChange = (value) => {
    setIsRowSelected(false); // Reset row selection when project name changes
    if (!value) {
      setSelectedProjectName("");
      // The useEffect will handle filtering when value is cleared
      return;
    } else {
      const normalizedValue = normalize(value);
      setSelectedProjectName(normalizedValue);
      // The useEffect will handle the filtering with partial matching
      // Check if any result has "project requested" status
      dispatch(fetchAllProjects());
    }
  };

  const handleClientNameChange = (value) => {
    setIsRowSelected(false); // Reset row selection when client changes
    if (!value) {
      setSelectedClient("");
      dispatch(setExistingSearchClientName(""))
      return;
    } else {
      const normalizedValue = normalize(value);
      setSelectedClient(normalizedValue);
      // The useEffect will handle the filtering with partial matching
    }
  }

  const handleQuotationIDSearch = (value) => {

    setQuotationNumber(value)
    const clientLeads = leads.filter(
      (lead) => lead?.quotationId === value
    );
    console.log("createdProject in search clientLeads", clientLeads)
    if (clientLeads[0]?.SalesPersonStatus === "project requested") {
      dispatch(setOperationProjectStatus("project requested"));
    }
  }

  const handleQuotationSearch = async (value) => {
    const quotationNumber = value
    try {
      await dispatch(fetchLeadByQuotationNumber(quotationNumber)).unwrap();
    } catch (error) {
      console.error("Error:", error);
    } finally {
      SetisLoading(false);
    }
  };


  const autoCompleteStyles = {
    width: "100%",
    "& .MuiInputBase-root": {
      padding: "1px 3px",     // reduce internal padding
      height: 36,             // control height
      borderRadius: 2,        // border radius
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#c4c4c4", // normal border
      },
      "&:hover fieldset": {
        borderColor: "#000",    // hover border
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1976d2", // focus border
      },
    },
    "& .MuiAutocomplete-listbox": {
      padding: 0,             // remove extra vertical padding
    },

    "& .MuiAutocomplete-option": {
      fontSize: "10px",       // reduce dropdown text size
      padding: "4px 4px",     // reduce vertical spacing
      minHeight: "24px",      // set fixed option height (optional)
    },
  };

  const operationProjectName = existingClientLeads[0]?.ProjectName;
  const operationProjectQuotationId = existingClientLeads[0]?.quotationId || QuotationNumber || null;
  const { SalesStatus } = useMatchedProject(operationProjectName, operationProjectQuotationId);

  // Set operation project status when lead is selected or SalesStatus changes
  useEffect(() => {
    if (existingClientLeads?.length > 0 && existingClientLeads[0]) {
      // Check if lead status is Won - skip Generate Quotation for Won status
      const leadStatus = existingClientLeads[0]?.Status?.toLowerCase()?.trim();
      const isWon = leadStatus === "won" || leadStatus === "won recurring";
      
      const leadSalesPersonStatus = existingClientLeads[0]?.SalesPersonStatus;
      let statusToSet = "";
      
      // CRITICAL: Always prioritize SalesStatus when available, especially for "response received"
      // This ensures correct navigation even on slower servers where data loads after initial render
      if (SalesStatus) {
        // If Won status, don't set to "generate quotation", go directly to P&L
        if (isWon && SalesStatus === "generate quotation") {
          // For Won status, we want to go to P&L Tracker, so set a status that will show P&L
          statusToSet = "project approved"; // This will show P&L Tracker in step 4
        } else {
          statusToSet = SalesStatus;
        }
      } else if (leadSalesPersonStatus === "project requested") {
        statusToSet = "project requested";
      } else if (leadSalesPersonStatus) {
        const statusMap = {
          "project requested": "project requested",
          "response received": "response received",
          "project approved": "project approved",
          "project assigned": "project assigned",
          "project ongoing": "project ongoing",
          "project complete": "project complete"
        };
        statusToSet = statusMap[leadSalesPersonStatus.toLowerCase()] || leadSalesPersonStatus;
      }
      
      // Always update if statusToSet is different from current operationProjectStatus
      // This is especially important for "response received" status to ensure correct wizard is shown
      // Note: We read operationProjectStatus from selector but don't include it in deps to avoid infinite loop
      if (statusToSet && statusToSet !== operationProjectStatus) {
        dispatch(setOperationProjectStatus(statusToSet));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [existingClientLeads, SalesStatus, dispatch]);

  const navigateToEdit = (proj) => {
    // Determine the operation project status
    let statusToSet = "";
    
    // CRITICAL: Always prioritize SalesStatus when available, especially for "response received"
    // This ensures correct navigation even on slower servers where data loads after initial render
    // SalesStatus comes from actual project data and is more reliable than leadSalesPersonStatus
    const leadSalesPersonStatus = proj?.SalesPersonStatus || existingClientLeads[0]?.SalesPersonStatus;
    
    if (SalesStatus) {
      // Use the matched project's status if available - this is the most reliable source
      statusToSet = SalesStatus;
    } else if (leadSalesPersonStatus === "project requested") {
      statusToSet = "project requested";
    } else if (leadSalesPersonStatus) {
      // Fallback to lead's SalesPersonStatus if matched project status is not available
      // Map common statuses
      const statusMap = {
        "project requested": "project requested",
        "response received": "response received",
        "project approved": "project approved",
        "project assigned": "project assigned",
        "project ongoing": "project ongoing",
        "project complete": "project complete"
      };
      statusToSet = statusMap[leadSalesPersonStatus.toLowerCase()] || leadSalesPersonStatus;
    }
    
    // Always set the status, even if empty (to avoid black screen)
    // Note: If SalesStatus is not available yet, the useEffect above will update it when it becomes available
    if (statusToSet) {
      dispatch(setOperationProjectStatus(statusToSet));
    } else {
      // Default to "project requested" if no status is found
      // The useEffect will update this when SalesStatus becomes available
      dispatch(setOperationProjectStatus("project requested"));
    }
    
    dispatch(setEditProjectID(proj?.id));
    // Set the selected lead in createdProject - use the passed proj parameter or the selected lead
    const selectedLead = proj ? [proj] : existingClientLeads;
    dispatch(setCreatedProject(selectedLead));
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [LeadToDelete, setLeadToDelete] = useState(null);

  const openDeleteModal = (id) => {
    setLeadToDelete(id);
    setIsModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setLeadToDelete(null);
  };

  const confirmDelete = async () => {
    if (LeadToDelete) {
      await deleteLeadReport(LeadToDelete);
    }
    closeDeleteModal();
  };
  const deleteLeadReport = async (id) => {
    try {
      const resultAction = await dispatch(deleteLead(id));
      if (deleteLead.fulfilled.match(resultAction)) {
        enqueueSnackbar("Lead deleted successfully!", { variant: "success" });
      } else {
        enqueueSnackbar("Failed to delete Lead report!", { variant: "error" });
      }
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar("Connection Error!", { variant: "error" });
    } finally {
      // setSelectedGroup("");
      // setExistingClientLeads([]);
      // handleProjectNameChange("");
      // setSelectedClient();
    }
  };

  const dropdownsRef = useRef(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openDropdownId && dropdownsRef.current && !dropdownsRef.current.contains(event.target)) {
        const clickedElement = event.target;
        const isEllipsisIcon = clickedElement.closest('.dropdown-toggle-icon');
        if (!isEllipsisIcon) {
          setOpenDropdownId(null);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdownId]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (createdProject?.length > 0) {
      setExistingClientLeads(createdProject)
    }
  }, [createdProject])

  return (
    <div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
      />
      <div className="flex flex-col lg:flex-row w-full py-3 gap-3 ">
        <div className="w-full lg:w-[25%]">
          <label className="text-sm font-medium">Search By Quotation ID</label>

          <Autocomplete
            freeSolo                         // allows typing like an input
            disablePortal
            options={searchedQuationNumber}        // 👈 dropdown values
            inputValue={QuotationNumber}     // 👈 same as input value
            onInputChange={(event, value) => {
              setIsRowSelected(false)
              handleQuotationIDSearch(value);     // 👈 same as onChange
              // setQuotationNumber(value);     // 👈 same as onChange
              dispatch(setExistingProjectLeadId(value));
              dispatch(setExistingProjectLeadId(""))
              setSelectedClient();
              handleProjectNameChange();
              setExistingClientLeads([]);
              dispatch(setExistingSearchClientName(""))
              dispatch(setExistingSearchProjectName(""))
              setSelectedGroup("");
            }}
            onChange={(event, value) => {
              handleQuotationIDSearch(value || "");
              // setQuotationNumber(value || "");
            }}
            sx={autoCompleteStyles}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Quotation No."
                variant="outlined"
                size="small"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleQuotationSearch(QuotationNumber); // 👈 same Enter logic
                  }
                }}
                InputProps={{
                  ...params.InputProps,
                  sx: {
                    padding: "0 !important",
                    backgroundColor: "white",
                  },
                }}
              />
            )}
          />
        </div>

        {/* Divider "or" */}
        <div className=" flex items-center justify-center gap-2 w-full lg:w-[7%] text-sm pt-4">
          <div className="hidden lg:block flex-1 h-px bg-black"></div>
          <span>or</span>
          <div className="hidden lg:block flex-1 h-px bg-black"></div>
        </div>

        {/* Autocomplete Section */}
        <div className="w-full lg:w-[64%] flex flex-col lg:flex-row gap-4">

          <div className="w-full">
            <label className="text-sm font-medium">Search Group Name</label>
            <Autocomplete
              freeSolo
              disablePortal
              options={Groups}
              inputValue={selectedGroup || ""}
              onInputChange={(event, value) => {
                setIsRowSelected(false)
                setSelectedGroup(value || "");
                setQuotationNumber("")
                dispatch(setExistingProjectLeadId(""))
                if (!value) {
                  setSelectedClient("");
                  setSelectedProjectName("");
                  dispatch(setExistingSearchClientName(""))
                  dispatch(setExistingSearchProjectName(""))
                }
              }}
              onChange={(event, value) => {
                setIsRowSelected(false)
                setSelectedGroup(value || "");
                setQuotationNumber("")
                dispatch(setExistingProjectLeadId(""))
                if (!value) {
                  setSelectedClient("");
                  setSelectedProjectName("");
                  dispatch(setExistingSearchClientName(""))
                  dispatch(setExistingSearchProjectName(""))
                }
              }}
              getOptionLabel={(option) => option || ""}
              sx={autoCompleteStyles}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Enter or Select Group"
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      padding: "0 !important",
                      backgroundColor: "white"   // ⬅️ Add this line
                    },
                  }}
                />
              )}
            />
          </div>

          {/* Client Name */}
          <div className="w-full">
            <label className="text-sm font-medium">Search Client Name</label>
            <Autocomplete
              freeSolo
              disablePortal
              options={uniqueClientLeads}
              inputValue={selectedClient || ""}
              onInputChange={(event, value) => {
                setIsRowSelected(false)
                handleClientNameChange(value)
                dispatch(setExistingSearchProjectName(""))
              }}
              onChange={(event, value) => {
                setIsRowSelected(false)
                handleClientNameChange(value || "")
                dispatch(setExistingSearchProjectName(""))
              }}
              getOptionLabel={(option) => option || ""}
              sx={autoCompleteStyles}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Enter or Select Client"
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      padding: "0 !important",
                      backgroundColor: "white"   // ⬅️ Add this line
                    },
                  }}
                />
              )}
            />
          </div>

          {/* Project Name */}
          <div className="w-full">
            <label className="text-sm font-medium">Search Project Name</label>
            <Autocomplete
              freeSolo
              disablePortal
              options={Projects}
              inputValue={selectedProjectName || ""}
              onInputChange={(event, value) => {
                setIsRowSelected(false)
                handleProjectNameChange(value)
              }}
              onChange={(event, value) => {
                setIsRowSelected(false)
                handleProjectNameChange(value || "")
              }}
              getOptionLabel={(option) => option || ""}
              sx={autoCompleteStyles}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Enter or Select Project"
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      padding: "0 !important",
                      backgroundColor: "white"   // ⬅️ Add this line

                    },
                  }}
                />
              )}
            />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-md w-[99%] min-h-[10rem] max-h-[90vh]  overflow-visible">

        {((wizardPlanState === "basicplan") && wizardProjectState === "existingProject") && (
          <>
            <div className="sticky top-0 head text-center text-xs font-semibold flex bg-[#E8E8E8] text-black ">
              <div className="w-[4%] break-words whitespace-normal border p-1 flex justify-center items-center">Sr. No</div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-center items-center truncate">
                Lead Date
              </div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">Client Name</div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">Project Name</div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">
                Lead Type
              </div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-center items-center truncate">
                Quoted Value ({currency})
              </div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">
                <span className='pl-3'>Status</span>
              </div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">
                Source
              </div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">Group</div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-center items-center truncate"> Follow-up Date </div>

              <div className="w-[10%] z-[499] break-words whitespace-normal border p-2 flex justify-center items-center">Action</div>
            </div>
            {currentItems?.map((proj, index) => (
              <div
                onClick={() => {
                  setIsRowSelected(true)
                  setCurrentPage(1) // Reset to first page when selecting a row
                  // Populate all fields when a lead is selected
                  setSelectedGroup(resolveLeadGroupName(proj) || "")
                  setSelectedClient(proj?.ClientName || "")
                  setSelectedProjectName(proj?.ProjectName || "")
                  setQuotationNumber(proj?.quotationId || "")
                  setExistingClientLeads([proj])
                  // Dispatch Redux actions to persist the values
                  dispatch(setExistingSearchGroupName(resolveLeadGroupName(proj) || ""))
                  dispatch(setExistingSearchClientName(proj?.ClientName || ""))
                  dispatch(setExistingSearchProjectName(proj?.ProjectName || ""))
                  dispatch(setExistingProjectLeadId(proj?.quotationId || ""))
                  // Set operation project status if needed
                  if (proj?.SalesPersonStatus === "project requested") {
                    dispatch(setOperationProjectStatus("project requested"));
                  }
                }}
                key={index}
                className="text-center text-xs flex hover:bg-gray-50 cursor-pointer">
                <div className="w-[4%] border-b p-1 flex justify-center items-center text-black">{index + 1}</div>
                <div className="w-[10%] border-b p-2 flex justify-center items-center truncate text-black">
                  {formatDateByCountry(proj?.LeadDate)}
                </div>
                <div className="w-[10%] capitalize break-words whitespace-normal border-b p-2 text-start flex justify-start items-center truncate text-black">
                  {proj?.ClientName}
                </div>
                <div className="w-[10%] break-words whitespace-normal border-b p-2 text-start flex justify-start items-center truncate text-black">
                  <span className='text-start capitalize'>{proj?.ProjectName}</span>
                </div>
                <div className="w-[10%] break-words border-b p-2 text-start flex justify-start items-center truncate text-black">
                  {proj?.LeadType}
                </div>
                <div className="w-[10%] break-words whitespace-normal border-b p-2 flex justify-center items-center truncate text-black">
                  {USAComma(proj?.QuotedValue)}
                </div>
                <div className="w-[10%] break-words whitespace-normal border-b p-2 text-start flex justify-start items-center truncate text-black">
                  <span className='pl-3 capitalize'>{proj?.Status}</span>
                </div>
                <div className="w-[10%] break-words whitespace-normal border-b p-2 text-start flex justify-start items-center truncate text-black">
                  {proj?.Source}
                </div>
                <div className="w-[10%] break-words whitespace-normal border-b p-2 text-start flex justify-start items-center truncate text-black">
                  {resolveLeadGroupName(proj)}
                </div>

                <div className="w-[10%] break-words whitespace-normal border-b p-2 flex justify-center items-center truncate text-black">
                  {formatDateByCountry(proj?.FollowupDate)}
                </div>

                <div className="w-[10%] break-words whitespace-normal border-b p-2 flex justify-around items-center text-black">
                  <div className="px-2 relative">
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        if (openDropdownId !== proj?.id) {
                          setOpenDropdownId(proj?.id);
                        } else {
                          setOpenDropdownId(null);
                        }
                      }}
                      className="p-1 cursor-pointer dropdown-toggle-icon"
                    >
                      <EllipsisVertical className='z-50' />
                    </div>
                    {openDropdownId === proj?.id && (
                      <div
                        ref={dropdownsRef}
                        className={`z-[3299] p-1 absolute flex flex-col ${index === existingClientLeads?.length - 1 ? 'bottom-full' : 'top-full'} -left-3 bg-white rounded-md shadow border`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div
                          onClick={() => {
                            if (existingClientLeads?.length > 0) {
                              navigateToEdit(existingClientLeads[0])
                              dispatch(setExistingEditAdvancedProject(true))
                              dispatch(goNext())
                            }
                            setOpenDropdownId(null);
                          }}
                          className="p-1 flex gap-1 w-full justify-start align-middle items-center border-b cursor-pointer hover:bg-gray-50"
                        >
                          <span title="Edit">
                            <SquarePen size={15} className="text-blue-500" />
                          </span>
                          Edit
                        </div>
                        <div
                          onClick={() => {
                            setOpenDropdownId(null);
                            openDeleteModal(proj?.id)
                          }}
                          className="p-1 flex gap-1 w-full justify-start align-middle items-center cursor-pointer hover:bg-gray-50"
                        >
                          <span title="Delete">
                            <Trash2 size={15} className="text-blue-500" />
                          </span>
                          Delete
                        </div>
                      </div>
                    )}
                  </div>

                </div>

              </div>
            ))}

            {currentItems?.length === 0 && (
              <div className="head  flex text-red-500 text-md">
                <p className="w-full text-start p-2">
                  No Data Available
                </p>
              </div>
            )}
          </>
        )}

        {(wizardPlanState === "advancedplan" && wizardProjectState === "existingProject") && (
          <>
            <div className="sticky top-0 head text-center text-xs flex bg-[#E8E8E8] text-black">
              <div className="w-[4%] break-words whitespace-normal border p-1 flex justify-center items-center">Sr. No</div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-center items-center truncate">
                Lead Date
              </div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">Client Name</div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">Project Name</div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">
                Lead Type
              </div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-center items-center truncate">
                Quoted Value ({currency})
              </div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">
                <span className='pl-3'>Status</span>
              </div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">
                Source
              </div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-start items-center truncate">Group</div>
              <div className="w-[10%] break-words whitespace-normal border p-2 flex justify-center items-center truncate"> Follow-up Date </div>

              <div className="w-[10%] z-[499] break-words whitespace-normal border p-2 flex justify-center items-center">Action</div>
            </div>
            {currentItems?.map((proj, index) => (
              <div
                onClick={() => {
                  setIsRowSelected(true)
                  setCurrentPage(1) // Reset to first page when selecting a row
                  // Populate all fields when a lead is selected
                  setSelectedGroup(resolveLeadGroupName(proj) || "")
                  setSelectedClient(proj?.ClientName || "")
                  setSelectedProjectName(proj?.ProjectName || "")
                  setQuotationNumber(proj?.quotationId || "")
                  setExistingClientLeads([proj])
                  // Dispatch Redux actions to persist the values
                  dispatch(setExistingSearchGroupName(resolveLeadGroupName(proj) || ""))
                  dispatch(setExistingSearchClientName(proj?.ClientName || ""))
                  dispatch(setExistingSearchProjectName(proj?.ProjectName || ""))
                  dispatch(setExistingProjectLeadId(proj?.quotationId || ""))
                  // Set operation project status if needed
                  if (proj?.SalesPersonStatus === "project requested") {
                    dispatch(setOperationProjectStatus("project requested"));
                  }
                }}
                key={index}
                className="text-center text-xs flex hover:bg-gray-50 cursor-pointer">
                <div className="w-[4%] border-b p-1 flex justify-center items-center text-black">{index + 1}</div>
                <div className="w-[10%] border-b p-2 flex justify-center items-center truncate text-black">
                  {formatDateByCountry(proj?.LeadDate)}
                </div>

                <div className="w-[10%] capitalize break-words whitespace-normal border-b p-2 text-start flex justify-start items-center truncate text-black">
                  {proj?.ClientName}
                </div>
                <div className="w-[10%] break-words whitespace-normal border-b p-2 text-start flex justify-start items-center truncate text-black">
                  <span className='text-start capitalize'>{proj?.ProjectName}</span>
                </div>
                <div className="w-[10%] break-words whitespace-normal border-b p-2 text-start flex justify-start items-center truncate text-black">
                  {proj?.LeadType}
                </div>
                <div className="w-[10%] break-words break-all whitespace-normal border-b p-2 flex justify-center items-center truncate text-black">
                  {USAComma(proj?.QuotedValue)}
                </div>
                <div className="w-[10%] capitalize break-words whitespace-normal border-b p-2 text-start flex justify-start items-center truncate text-black">
                  <span className='pl-3 capitalize'>{proj?.Status}</span>
                </div>
                <div className="w-[10%] break-words whitespace-normal border-b p-2 text-start flex justify-start items-center truncate text-black">
                  {proj?.Source}
                </div>
                <div className="w-[10%] break-words whitespace-normal border-b p-2 text-start flex justify-start items-center truncate text-black">
                  {resolveLeadGroupName(proj)}
                </div>

                <div className="w-[10%] break-words whitespace-normal border-b p-2 flex justify-center items-center truncate text-black">
                  {formatDateByCountry(proj?.FollowupDate)}
                </div>

                <div className="w-[10%] break-words whitespace-normal border-b p-2 flex justify-around items-center text-black">
                  <div className="px-2 relative">
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        if (openDropdownId !== proj?.id) {
                          setOpenDropdownId(proj?.id);
                        } else {
                          setOpenDropdownId(null);
                        }
                      }}
                      className="p-1 cursor-pointer dropdown-toggle-icon"
                    >
                      <EllipsisVertical className='z-50' />
                    </div>
                    {openDropdownId === proj?.id && (
                      <div
                        ref={dropdownsRef}
                        className={`z-[3299] p-1 absolute flex flex-col ${index === existingClientLeads?.length - 1 ? 'bottom-full' : 'top-full'} -left-3 bg-white rounded-md shadow border`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div
                          onClick={() => {
                            if (existingClientLeads?.length > 0) {
                              navigateToEdit(existingClientLeads[0])
                              dispatch(setExistingEditAdvancedProject(true))
                              dispatch(goNext())
                            }
                            setOpenDropdownId(null);
                          }}
                          className="p-1 flex gap-1 w-full justify-start align-middle items-center border-b cursor-pointer hover:bg-gray-50"
                        >
                          <span title="Edit">
                            <SquarePen size={15} className="text-blue-500" />
                          </span>
                          Edit
                        </div>
                        <div
                          onClick={() => {
                            setOpenDropdownId(null);
                            openDeleteModal(proj?.id)
                          }}
                          className="p-1 flex gap-1 w-full justify-start align-middle items-center cursor-pointer hover:bg-gray-50"
                        >
                          <span title="Delete">
                            <Trash2 size={15} className="text-blue-500" />
                          </span>
                          Delete
                        </div>
                      </div>
                    )}
                  </div>

                </div>
              </div>
            ))}

            {currentItems?.length === 0 && (
              <div className="head  flex text-red-500 text-md">
                <p className="w-full text-start p-2">
                  No Data Available
                </p>
              </div>
            )}
          </>
        )}
      </div>
      <div className="pagination flex justify-between items-center bg-white rounded-md py-2 pl-2">
        <div>
          {totalItems > 0 ? (
            <>
              Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
              {totalItems} Entries
            </>
          ) : (
            <>{currentItems?.length > 1 && (
              <span> Showing 0 Entries</span>
            )}</>
          )}
        </div>
        {totalPages > 1 && (
          <div>
            <button
              onClick={() => setCurrentPage(1)}
              className="px-1 py-1 mx-1 border rounded"
              disabled={currentPage === 1}
              title="First Page"
            >
              <KeyboardDoubleArrowLeftIcon className="w-4 h-4" />
            </button>
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              className="px-1 py-1 mx-2 border rounded"
              disabled={currentPage === 1}
            >
              <ChevronRightIcon className="w-4 h-4 rotate-180" />
            </button>

            {Array.from({ length: 3 }, (_, index) => {
              const pageNumber = currentPage - 1 + index;
              if (pageNumber >= 1 && pageNumber <= totalPages) {
                return (
                  <button
                    key={pageNumber}
                    onClick={() => setCurrentPage(pageNumber)}
                    className={`px-3 py-1 mx-2 border rounded ${currentPage === pageNumber ? "bg-gray-300 border" : ""
                      }`}
                  >
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })}

            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              className="px-1 py-1 mx-2 border rounded"
              disabled={currentPage === totalPages}
            >
              <ChevronRightIcon className="w-4 h-4" />
            </button>
            <button
              onClick={() => setCurrentPage(totalPages)}
              className="px-1 py-1 mx-1 border rounded"
              disabled={currentPage === totalPages}
              title="Last Page"
            >
              <KeyboardDoubleArrowRightIcon className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>



      <div className='w-[99%] flex justify-end'>
        <div className="flex gap-4 pt-2">
          <button
            onClick={() => {
              if (step === 1) {
                // Navigate to dashboard first
                navigate('/dashboard');
                // Reset wizard state but preserve wizardPlanState (it will be set by Wizard component's useEffect)
                dispatch(setCreatedProject([]))
                dispatch(resetStep())
                dispatch(setcurrentLeadID(""))
                // Clear search-related state
                dispatch(setExistingSearchGroupName(""))
                dispatch(setExistingSearchClientName(""))
                dispatch(setExistingSearchProjectName(""))
                dispatch(setExistingProjectLeadId(""))
                dispatch(setExistingEditAdvancedProject(false))
                // Show the wizard modal
                dispatch(setShowWizard(true));
              }
            }}
            className={`bg-black text-white cursor-pointer py-2 px-7  overflow-hidden shadow-md  rounded-lg `}
          >
            Back
          </button>

          <button
            disabled={currentItems?.length === 0}
            onClick={() => {
              if (currentItems?.length === 1) {
                navigateToEdit(currentItems[0])
                if (wizardPlanState === "basicplan" && wizardProjectState === "existingProject") {
                  dispatch(goNext(3))
                } else {
                  dispatch(goToStep(3))
                }
              }

            }}
            className={` ${currentItems?.length === 1 ? "bg-[#e32278] cursor-pointer " : "bg-[#f4aecd] cursor-default"} py-2 px-7  overflow-hidden shadow-md text-white rounded-lg`}
          >
            Next
          </button>
        </div>

      </div>

    </div>
  )
}

export default ExistingProjectSearch
